import { AxiosError } from 'axios';
import { AutocompleteOption } from '@dxb-web-ui-framework/design-system';
import { KeyedMutator } from 'swr/dist';
import { GenericObject, Nullable } from '@dxb-web-ui-framework/common/types';
import { APIGatewayResponse } from '@dxb-web-ui-framework/common/domain/RestfulDataTransfer/DataService/types';
import { Card } from '../../domain/Card/entities/Card';
import { CardInfoListResponseBody, CardListPagination } from '../../types';

export type PopularCard = {
  cardId: string;
  viewsCount: number;
};

export type CardsStateArgs = {
  popularCards?: { [key: string]: PopularCard[] };
};

export type CardsListFilters = {
  cardNumberSuffix?: string;
  paymentCardStatuses?: number;
  cardholderIdentification?: AutocompleteOption;
};

export interface CardsState {
  cardListData?: Nullable<Card[]>;
  pagination: Partial<CardListPagination>;
  isCorporate: boolean;
  cardsListFilters: Partial<CardsListFilters & { timestamp?: string }>;
  onCardsListFiltersChange: (filters: Partial<CardsListFilters>, nextPage?: number, totalPages?: number) => void;
  meta: {
    timestamp: string;
  };
  // TODO: change this to contain arrays for multiple customerIds
  popularCards?: GenericObject;
  errorState: {
    cardListDataError?: AxiosError<APIGatewayResponse<any>, any>;
  };
  loadingState: {
    isLoadingCardListData: boolean;
  };
  onSetPopularCards: (customerId: string, cardId: string, popularCards: GenericObject<any>) => void;
  onSetPagination: (pageSize: number, pageNumber?: number) => void;
  refetchCardsDataMutation?: KeyedMutator<CardInfoListResponseBody>;
}

export type CardSize = 'sm' | 'md' | 'lg';

export enum CardContextActionTypes {
  ResetCards = '@@Cards/RESET_CARDS',
  SetPagination = '@@/Cards/SET_PAGINATION',
  SetCardsListFilters = '@@/Cards/SET_CARDS_LIST_FILTERS',
}
